export const siteSettings = {
  name: "Sage Markets",
  link: "https://sagemarkets.net",
  email: "support@sagemarkets.net",
  appLink: "https://app.sagemarkets.net",
};
